export const supportWidgetPaths = {
  home: () => "/",
  posts: (id: string) => `/spaces/${id}/posts`,
  spaceGroups: () => "/space_groups",
  form: () => "/form",
  showPost: (id: string) => `/posts/${id}`,
  showConversation: (id: string) => `/conversations/${id}`,
  askChatBot: () => "/ask",
};
